/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_Station_EmptyInputs */

const vi_camera_station_empty = /** @type {(inputs: Camera_Station_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trạm này chưa gắn camera`)
};

/**

* @param {Camera_Station_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const camera_station_empty = /** @type {((inputs?: Camera_Station_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_Station_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_camera_station_empty(inputs)
});